/**
 * Validate common data.
 *
 * @see [Rubicon](https://docs.devac.de/rubicon/)
 */

import {
  AND,
  ARRAY,
  BOOLEAN,
  CONST,
  INTEGER,
  NULLABLE,
  OBJECT,
  OPTIONAL,
  RECORD,
  STRING,
} from '@acng/frontend-rubicon';
import {AUTH_USER_DATA} from './user.js';
import {IMAGE_FORMAT} from './image.js';
import {LANGUAGE} from './lang.js';
import {FSK_KEY} from './fsk.js';

const BUILD_INFO = /* @__PURE__ */ OBJECT({
  enableAsserts: BOOLEAN,
  throwFailedAsserts: BOOLEAN,
  enableDebug: BOOLEAN,
  enableEventSource: BOOLEAN,
  eventSourceUrl: STRING,
});

const MEDIA = /* @__PURE__ */ OBJECT({
  content: OBJECT({
    movies: STRING,
    pictures: STRING,
    items: STRING,
  }),
  assets: STRING,
  assets_ext: STRING,
  user: STRING,
});

const DUMMY_IMAGE_MAP = /* @__PURE__ */ AND(OBJECT({default: ARRAY(STRING)}), RECORD(IMAGE_FORMAT, OPTIONAL(ARRAY(STRING))));

export const ENV = /* @__PURE__ */ (() =>
  OBJECT({
    BUILD: BUILD_INFO,
    authUser: NULLABLE(AUTH_USER_DATA),
    media: MEDIA,
    FEATURES: ARRAY(STRING),
    INHERIT: ARRAY(STRING),
    hasMyPortal: BOOLEAN,
    startUpCountry: LANGUAGE,
    startUpLanguage: LANGUAGE,
    startUpFsk: FSK_KEY,
    VERSION: STRING,
    API_cdn: STRING,
    API_origin: STRING,
    SWFile: STRING,
    isMobile: BOOLEAN,
    SONUS: STRING,
    UTM: STRING,
    PLAYPAL_STATIC: STRING,
    ARCHIMEDES: STRING,
    TROI: STRING,
    OBRIEN: STRING,
    HELLO: STRING,
    RATATOSKR: STRING,
    LaForge: STRING,
    //todo: remove old dummy image map entries and use only named records none, adult and underage
    dummyImageMap: AND(OBJECT({none: DUMMY_IMAGE_MAP, underage: DUMMY_IMAGE_MAP})),
    livecamStartFactor: CONST('1'),
    webmailDomains: RECORD(STRING, ARRAY(STRING)),
    sid: STRING,
    paymentConfig: OBJECT({
      flow: CONST('productsFirst'),
      packages: OBJECT({
        sorting: OBJECT({
          key: STRING,
          order: STRING,
        }),
      }),
    }),
    freeCoinsConfig: OBJECT({value: INTEGER}),
    TagToTopicMapping: RECORD(STRING, STRING),
    SystemCdnUsage: BOOLEAN,
  }))();
